export default __webpack_public_path__ + "static/media/leaf6.4359c3dc.svg";